import { useState } from 'react';
import PropTypes from 'prop-types';
import { Eye, EyeOff } from 'lucide-react';
import InputWithIcon from './InputWithIcon';
import './PasswordInput.scss';

// InputWithIcon for passwords, with an eye button that reveals what was typed.
const PasswordInput = ({ className = '', ...props }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className={`password-input ${className}`}>
      <InputWithIcon {...props} type={isVisible ? 'text' : 'password'} />
      <button
        type="button"
        className="password-input-toggle"
        onClick={() => setIsVisible(visible => !visible)}
        aria-label={isVisible ? 'הסתרת הסיסמה' : 'הצגת הסיסמה'}
        aria-pressed={isVisible}
      >
        {isVisible ? <EyeOff size={20} /> : <Eye size={20} />}
      </button>
    </div>
  );
};

PasswordInput.propTypes = {
  className: PropTypes.string,
};

export default PasswordInput;
